module.exports = __webpack_public_path__ + "media/evolve/assets/icons/fontawesome/regular/file-pdf-cdc4bec36c0ea247cb7c9d6ed01ecbc0.svg";